import { Inject, Injectable } from "@angular/core";
import { HttpClient, HttpParams } from "@angular/common/http";
import { Observable } from "rxjs";
import { LearnerCourseLog } from "../_models/LearnerCourseLog";
import { BaseService } from "./base-service";
import { catchError } from "rxjs/operators";
import { IAppConfig } from "../lib/config/app-config";
import { APP_CONFIG } from "../lib/angular/injection-tokens";
import { AppConstants } from "../constants/constants";

@Injectable({
  providedIn: "root",
})
export class LearnerCourseLogService extends BaseService {
  private baseUrl: string = this.config.protectedResourceEndpoint;
  private static readonly PATH: string = "LearnerCourseLog/";
  private static readonly STATUS: string = "status/";
  private static readonly LEARNER_STATUS: string = "learner/status";
  private static readonly STARTEDCOURSES: string = "startedCourses/";
  private static readonly TRACK: string = "track/";
  private static readonly REASSIGN_ASSESSMENT: string = "reassign-assessment/";
  private static readonly GENERATE_LEARNING_PLAN: string = "generate-learning-plan/";
  private static readonly LEARNING_PLAN_GENERATED: string = "learning-plan-generated/";

  constructor(http: HttpClient, @Inject(APP_CONFIG) private config: IAppConfig) {
    super(http);
  }

  public getLearnerCourseLog$(courseId: number): Observable<LearnerCourseLog> {
    let params = new HttpParams().set("courseId", String(courseId));

    return this.http
      .get<LearnerCourseLog>(
        this.baseUrl +
        LearnerCourseLogService.PATH +
        LearnerCourseLogService.STATUS,
        { params }
      )
      .pipe(catchError(this.handleError));
  }

  public getLearnerCourseLogByLearnerAndCourseId$(learnerId: number, courseId: number): Observable<LearnerCourseLog> {
    let params = new HttpParams();
    params = params.append(AppConstants.LEARNER_ID, String(learnerId));
    params = params.append(AppConstants.COURSE_ID, String(courseId));

    return this.http
      .get<LearnerCourseLog>(
        this.baseUrl +
        LearnerCourseLogService.PATH +
        LearnerCourseLogService.LEARNER_STATUS,
        { params }
      );
  }

  public getStartedCourses$(): Observable<number[]> {
    return this.http
      .get<number[]>(
        this.baseUrl +
        LearnerCourseLogService.PATH +
        LearnerCourseLogService.STARTEDCOURSES
      )
      .pipe(catchError(this.handleError));
  }

  public trackLearnerCourseVisit$(lclId: number) {
    return this.http
      .put(
        this.baseUrl +
        LearnerCourseLogService.PATH +
        LearnerCourseLogService.TRACK +
        lclId,
        null
      )
      .pipe(catchError(this.handleError));
  }

  public updateLearnerCourseLog$(lclId: number, learnerCourseLog?: LearnerCourseLog) {
    return this.http
      .put(
        this.baseUrl +
        LearnerCourseLogService.PATH +
        lclId,
        learnerCourseLog
      )
      .pipe(catchError(this.handleError));
  }

  public reassignLearnerToInitialAssessment$(courseId: number): Observable<number> {
    return this.http.put<number>(
      this.baseUrl + LearnerCourseLogService.PATH +
      LearnerCourseLogService.REASSIGN_ASSESSMENT + courseId,
      null
    );
  }

  public isLearningPlanGenerated$(courseId: number): Observable<boolean> {
    return this.http.get<boolean>(
      this.baseUrl + LearnerCourseLogService.PATH +
      LearnerCourseLogService.LEARNING_PLAN_GENERATED + courseId
    );
  }

  public generateLearningPlan$(courseId: number): Observable<number> {
    return this.http.put<number>(
      this.baseUrl + LearnerCourseLogService.PATH +
      LearnerCourseLogService.GENERATE_LEARNING_PLAN + courseId,
      null
    );
  }
}
